export default "__VITE_ASSET__ccceab3f__"